// Product analytics from the browser. Two kinds:
// - trackServer: a few UI moments the server can't see (feedback viewed,
//   next question clicked). Sent to our own API, stored first-party, and
//   forwarded to PostHog by the server. No cookies involved.
// - trackPosthog: page-level events straight to PostHog, only after the
//   visitor accepts cookies (index.html keeps PostHog opted out until then).

import axios from "axios";
import { consentChoice } from "./consent";

export function trackServer(event, props = {}) {
  try {
    if (!localStorage.getItem("jwtToken")) return;
  } catch {
    return;
  }
  axios.post("/api/insights/track", { event, props }).catch(() => {});
}

export function trackPosthog(event, props = {}) {
  try {
    if (consentChoice() !== "granted") return;
    const ph = window.posthog;
    if (ph && typeof ph.capture === "function") ph.capture(event, props);
  } catch {
    /* analytics must never break the page */
  }
}

// Ties PostHog to the signed-in account by id only, never email or name.
export function identify(userId) {
  try {
    if (!userId || consentChoice() !== "granted") return;
    const ph = window.posthog;
    if (ph && typeof ph.identify === "function") ph.identify(String(userId));
  } catch {
    /* ignore */
  }
}
